<template>
  <div class="t-calc__info">
    {{ title }}
    <span><slot /></span>
  </div>
</template>

<script>
export default {
  name: "OQHint",
  props: ["title"],
};
</script>

<style scoped></style>
